import InlineAlert from "@storeblocks/inline-alert";
import { InsuranceAdviceCard } from "Components/InsuranceAdvice/InsuranceAdviceCard";
import { useTexts } from "Components/TextContext";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { ChildCoverage } from "Store/interfaces/products/coverage";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { isDefined } from "Utils/functions";
import { replacePlaceholder } from "Utils/replacePlaceholder";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import { CHILD_MAX_AGE } from "../../../LifeProducts/Child/childConstants";
import { CoverageWarningTexts } from "../../ProductPriceAka/AkaAdviceCards/CloseToMaxAgeWarning";
import { useAdviceDetailsFormValues } from "../hooks/stateSelectors";
import { hasChildCloseToMaxAge, isChildInsuranceRecommended } from "../utils";
import { CHILD_END_AGE } from "./adviceCardConstants";

export const ChildAdviceCard = (): React.ReactElement | null => {
  const adviceDetails = useAdviceDetailsFormValues();
  const isAdvisor = useIsAdvisorSelector();
  const { getText } = useTexts();
  const [
    {
      formText: { advice: adviceTexts },
    },
    lang,
  ] = useProductTexts(getFMSProductName(ProductBackendName.ADVICE));
  const toggleChildAdvice = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1335_ADVICE_PRICE_STEP_CHILD_ADVICE,
  );
  if (!toggleChildAdvice) {
    return null;
  }

  if (
    !isDefined(adviceDetails) ||
    !isChildInsuranceRecommended(adviceDetails)
  ) {
    return null;
  }

  const descriptionTextId = isAdvisor
    ? "advicepage.child.descriptionadvisor_v3"
    : "advicepage.child.descriptionnew";
  const warningTexts: CoverageWarningTexts =
    adviceTexts.adviceCards.child.warnings.CHILD;
  return (
    <>
      <InsuranceAdviceCard
        product={{
          name: INSURANCE_NAME_VALUE.CHILD,
          coverageGroup: ChildCoverage.EXTRA,
        }}
        title={getText("advicepage.child.label")}
        space="8px"
      >
        {getText(descriptionTextId, { variables: { maxAge: CHILD_MAX_AGE } })}
      </InsuranceAdviceCard>
      {hasChildCloseToMaxAge(adviceDetails) && (
        <InlineAlert
          title={replacePlaceholder(warningTexts.closeToMaxAge[lang], {
            maxAge: String(CHILD_MAX_AGE),
            endAge: String(CHILD_END_AGE),
          })}
        />
      )}
    </>
  );
};
